import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import { getSystemFlags } from 'core/core.selectors';
import { MOCKED_DATA_ALERT_CONTAINER } from '@features/regional-overview/domain/tests-id.constants';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export type MarginStyle = Pick<CSSProperties, 'margin' | 'marginLeft' | 'marginRight' | 'marginTop' | 'marginBottom'>;

interface MockedDataAlertComponentProps {
  isDemo?: boolean;
  hasShiftData?: boolean;
  style?: MarginStyle;
}
const MockedDataAlertComponent = ({ isDemo, hasShiftData, style }: MockedDataAlertComponentProps) => {
  const [t] = useTranslation();

  const systemFlags = useSelector(getSystemFlags);
  const isAlertEnabled = systemFlags?.P40_55174_regional_overview_shift_alert;

  const getMessage = () => {
    if (isDemo) return t('pages.regional_overview.demo_message');
    if (hasShiftData) return t('pages.regional_overview.shift_data_message');
    return undefined;
  };

  const message = getMessage();

  if (!message || !isAlertEnabled) return null;

  return (
    <Alert
      style={style}
      type='info'
      showIcon
      closable
      icon={<InfoCircleOutlined />}
      description={message}
      data-testid={MOCKED_DATA_ALERT_CONTAINER}
    />
  );
};

export default MockedDataAlertComponent;
